var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "padding-bottom": "0.98rem", "padding-top": "1.4rem" } },
    [
      _c("newsTopBox", { attrs: { title: "咨询" } }),
      _vm._v(" "),
      _c("div", { staticClass: "bannerBox" }),
      _vm._v(" "),
      _c("div", { staticClass: "titleBox" }, [_vm._v("预约咨询")]),
      _vm._v(" "),
      _c("div", { staticClass: "reducibleList" }, [
        _c(
          "div",
          {
            staticClass: "reducibleItem",
            class: { active: !_vm.bespeakAbled },
            on: {
              click: function($event) {
                _vm.changeBespeakAbled(0)
              }
            }
          },
          [_vm._v("\n      全部咨询师\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "reducibleItem",
            class: { active: _vm.bespeakAbled },
            on: {
              click: function($event) {
                _vm.changeBespeakAbled(1)
              }
            }
          },
          [_vm._v("\n      可预约咨询\n    ")]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "reducibleList" },
        _vm._l(_vm.doctorCampusList, function(item) {
          return _c(
            "div",
            {
              staticClass: "reducibleItem",
              class: { active: _vm.campusLocation == item },
              on: {
                click: function($event) {
                  _vm.changeCampusLocation(item)
                }
              }
            },
            [_vm._v("\n      " + _vm._s(item) + "\n    ")]
          )
        })
      ),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "expertList" },
        _vm._l(_vm.doctorList, function(item) {
          return _c(
            "li",
            {
              staticClass: "expertItem",
              on: {
                click: function($event) {
                  _vm.to("expertDetail?doctorId=" + item.doctorId)
                }
              }
            },
            [
              _c("img", {
                staticClass: "avatar",
                attrs: { src: _vm.EnvUrl + item.doctorWorkPhoto, alt: "" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "expertBox" }, [
                _c("div", { staticClass: "nameBox" }, [
                  _c("div", { staticClass: "name" }, [
                    _vm._v(_vm._s(item.doctorName))
                  ]),
                  _vm._v(" "),
                  _vm._v(
                    "\n          " +
                      _vm._s(item.doctorHospitalLevel) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "advantage" }, [
                  _vm._v("\n          咨询师介绍："),
                  _c("span", {
                    domProps: { innerHTML: _vm._s(item.doctorProfile) }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "lastBox" }, [
                  _c("ul", { staticClass: "expertTag" }, [
                    item.chatDoctorServe.video
                      ? _c("li", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                item.chatDoctorServe.video ? "视频咨询" : ""
                              ) +
                              "\n              "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    item.chatDoctorServe.telephone
                      ? _c("li", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                item.chatDoctorServe.telephone ? "电话疏导" : ""
                              ) +
                              "\n            "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    item.chatDoctorServe.imageText
                      ? _c("li", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                item.chatDoctorServe.imageText ? "图文咨询" : ""
                              ) +
                              "\n              "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    item.chatDoctorServe.offline
                      ? _c("li", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                item.chatDoctorServe.offline ? "线下咨询" : ""
                              ) +
                              "\n            "
                          )
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                item.chatDoctorServe.remark && item.chatDoctorServe.offline
                  ? _c("div", { staticClass: "addressBox" }, [
                      _vm._v(
                        "\n          线下地址：" +
                          _vm._s(item.chatDoctorServe.remark) +
                          "\n        "
                      )
                    ])
                  : _vm._e()
              ])
            ]
          )
        })
      ),
      _vm._v(" "),
      _c("no-more-data", { attrs: { noMoreData: _vm.noMoreData } }),
      _vm._v(" "),
      _c("footerBox", { attrs: { active: "2" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70e22419", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70e22419","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/ask.vue
// module id = null
// module chunks = 